import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';

@CopyProperties()
export class Gold {
  id: number;
  code: string;
  name: string;
  nameEn: string;
  shortName: string;
  description: string;
  descriptionEn: string;
  goldTypeCode: string;
  imageUrl: string;
  type: string;
  buyValue: number;
  sellValue: number;
  productGold: any;
  constructor(
    params?: any
  ) {
    this.id = 0;
    this.code = '';
    this.name = '';
    this.nameEn = '';
    this.shortName = '';
    this.description = '';
    this.descriptionEn = '';
    this.type = '';
    this.imageUrl = '';
    this.goldTypeCode = '';
    this.buyValue = 0;
    this.sellValue = 0;
    this.productGold = null;
  }
}
